import { makeStyles } from '@material-ui/core/styles';

const useGlobalStyles = makeStyles(theme => ({
  '@global': {
    body: {
      overflowX: 'hidden',
    },
    figure: {
      margin: theme.spacing(1, 0),
    },
    '.full': {
      // width: '100vw',
      // left: '50%',
      // right: '50%',
      // marginLeft: '-50vw',
      // marginRight: '-50vw',
      // position: 'relative',
      // clear: 'both',
      // margin: theme.spacing(0, 3),
      marginLeft: 'calc(50% - 50vw)',
      marginRight: 'calc(50% - 50vw)',
      '@global img': {
        height: '500px !important',
      },
      '&.caption': {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
    },
    '.left': {
      [theme.breakpoints.up('sm')]: {
        float: 'left',
        clear: 'both',
        width: '33.3%',
        marginRight: theme.spacing(4),
      },
      '@global iframe': {
        minHeight: 'auto',
      },
      // marginTop: theme.spacing(4),
    },
    '.right': {
      [theme.breakpoints.up('sm')]: {
        float: 'right',
        clear: 'both',
        width: '33.3%',
        marginLeft: theme.spacing(4),
      },
      '@global iframe': {
        minHeight: 'auto',
      },
      // marginTop: theme.spacing(4),
    },
    '.small': {
      maxWidth: '50%',
      margin: 'auto',
    },
    '.title': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Titel der Seite"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.subtitle': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Untertitel der Seite"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.place': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Veranstaltungsort"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.website': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Firmenwebsite"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.address': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Straße/Hausnummer, PLZ/Ort"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.phone': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"+49 123 45678910"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.email': {
      position: 'relative',
      '&.isEmpty.editMode': {
        '&:before': {
          userSelect: 'none',
          pointerEvents: 'none',
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"max@mustermann.de"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.header-two': {
      '&.faq.isEmpty.editMode': {
        '&:before': {
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          // left:0,
          content: '"Frage"',
          transform: 'translate(-50%,0)',
        },
      },
    },
    '.first-paragraph': {
      '&.isEmpty.editMode': {
        '&:before': {
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          content: '"Fangen Sie hier an zu schreiben..."',
        },
      },
    },
    '.caption': {
      '&.isEmpty.editMode': {
        '&:before': {
          color: theme.editorPalette.text.disabled,
          position: 'absolute',
          content: '"Bildunterschrift eingeben"',
        },
      },
    },
  },
}));

export default useGlobalStyles;
